import { useEffect } from 'react';

// Mientras una hoja está abierta, el botón "atrás" de Android la cierra en vez
// de cambiar de pantalla (ver components/BotonAtras.jsx).
export function useAtrasCierra(abierta, cerrar) {
  useEffect(() => {
    if (!abierta) return undefined;
    const alAtras = (e) => { e.preventDefault(); cerrar?.(); };
    window.addEventListener('gc-atras', alAtras);
    return () => window.removeEventListener('gc-atras', alAtras);
  }, [abierta, cerrar]);
}
